import React from "react";

const containerStyle = {
  width: "25%",
  textAlign: "center",
  maxWidth: 100,
  flex: 1
};

export const TIER_PRELH = "preLifeHistory";
export const TIER_PRERISK = "preRiskAssessment";
export const TIER_LOW = "data-poor";
export const TIER_MID = "data-mid";
export const TIER_HIGH = "data-high";

const DataPoorIcon = () => (
  <svg width="30" height="29" xmlns="http://www.w3.org/2000/svg" overflow="hidden">
    <defs><clipPath id="dataPoorIcon"><path d="M528 343 558 343 558 372 528 372Z" fill-rule="evenodd" clip-rule="evenodd"/></clipPath></defs>
    <g clip-path="url(#clip0)" transform="translate(-528 -343)">
      <path d="M549.5 345.667C549.5 345.022 550.022 344.5 550.667 344.5L555.333 344.5C555.978 344.5 556.5 345.022 556.5 345.667L556.5 370.333C556.5 370.978 555.978 371.5 555.333 371.5L550.667 371.5C550.022 371.5 549.5 370.978 549.5 370.333Z" stroke="#000000" stroke-width="1.33333" stroke-miterlimit="8" fill="#FFFFFF" fill-rule="evenodd"/>
      <path d="M539.5 354.667C539.5 354.022 540.022 353.5 540.667 353.5L545.333 353.5C545.978 353.5 546.5 354.022 546.5 354.667L546.5 370.333C546.5 370.978 545.978 371.5 545.333 371.5L540.667 371.5C540.022 371.5 539.5 370.978 539.5 370.333Z" stroke="#000000" stroke-width="1.33333" stroke-miterlimit="8" fill="#FFFFFF" fill-rule="evenodd"/>
      <path d="M529.5 363.667C529.5 363.022 530.022 362.5 530.667 362.5L535.333 362.5C535.978 362.5 536.5 363.022 536.5 363.667L536.5 370.333C536.5 370.978 535.978 371.5 535.333 371.5L530.667 371.5C530.022 371.5 529.5 370.978 529.5 370.333Z" stroke="#000000" stroke-width="1.33333" stroke-miterlimit="8" fill-rule="evenodd"/>
    </g>
  </svg>
);

const DataModerateIcon = () => (
  <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg" overflow="hidden">
    <defs><clipPath id="dataModIcon"><path d="M528 412 558 412 558 442 528 442Z" fill-rule="evenodd" clip-rule="evenodd"/></clipPath></defs>
    <g clip-path="url(#clip0)" transform="translate(-528 -412)">
      <path d="M549.5 414.667C549.5 414.022 550.022 413.5 550.667 413.5L555.333 413.5C555.978 413.5 556.5 414.022 556.5 414.667L556.5 439.333C556.5 439.978 555.978 440.5 555.333 440.5L550.667 440.5C550.022 440.5 549.5 439.978 549.5 439.333Z" stroke="#000000" stroke-width="1.33333" stroke-miterlimit="8" fill="#FFFFFF" fill-rule="evenodd"/>
      <path d="M539.5 423.667C539.5 423.022 540.022 422.5 540.667 422.5L545.333 422.5C545.978 422.5 546.5 423.022 546.5 423.667L546.5 439.333C546.5 439.978 545.978 440.5 545.333 440.5L540.667 440.5C540.022 440.5 539.5 439.978 539.5 439.333Z" stroke="#000000" stroke-width="1.33333" stroke-miterlimit="8" fill-rule="evenodd"/>
      <path d="M529.5 433.667C529.5 433.022 530.022 432.5 530.667 432.5L535.333 432.5C535.978 432.5 536.5 433.022 536.5 433.667L536.5 439.333C536.5 439.978 535.978 440.5 535.333 440.5L530.667 440.5C530.022 440.5 529.5 439.978 529.5 439.333Z" stroke="#000000" stroke-width="1.33333" stroke-miterlimit="8" fill-rule="evenodd"/>
    </g>
  </svg>
);

const DataRichIcon = () => (
  <svg width="30" height="29" xmlns="http://www.w3.org/2000/svg" overflow="hidden">
    <defs><clipPath id="dataRichIcon"><path d="M528 514 558 514 558 543 528 543Z" fill-rule="evenodd" clip-rule="evenodd"/></clipPath></defs>
    <g clip-path="url(#clip0)" transform="translate(-528 -514)">
      <path d="M549.5 516.667C549.5 516.022 550.022 515.5 550.667 515.5L555.333 515.5C555.978 515.5 556.5 516.022 556.5 516.667L556.5 541.333C556.5 541.978 555.978 542.5 555.333 542.5L550.667 542.5C550.022 542.5 549.5 541.978 549.5 541.333Z" stroke="#000000" stroke-width="1.33333" stroke-miterlimit="8" fill-rule="evenodd"/>
      <path d="M539.5 525.667C539.5 525.022 540.022 524.5 540.667 524.5L545.333 524.5C545.978 524.5 546.5 525.022 546.5 525.667L546.5 541.333C546.5 541.978 545.978 542.5 545.333 542.5L540.667 542.5C540.022 542.5 539.5 541.978 539.5 541.333Z" stroke="#000000" stroke-width="1.33333" stroke-miterlimit="8" fill-rule="evenodd"/>
      <path d="M529.5 535.667C529.5 535.022 530.022 534.5 530.667 534.5L535.333 534.5C535.978 534.5 536.5 535.022 536.5 535.667L536.5 541.333C536.5 541.978 535.978 542.5 535.333 542.5L530.667 542.5C530.022 542.5 529.5 541.978 529.5 541.333Z" stroke="#000000" stroke-width="1.33333" stroke-miterlimit="8" fill-rule="evenodd"/>
    </g>
  </svg>
);

export const assessmentTiers = [
  {id: TIER_PRERISK, title: "Stock Prioritization", sortOrder:5, icon:"SP" },
  {id: TIER_PRELH, title: "Pre-assessment - Life-History Based Reference Points", sortOrder:4, icon:"RP" },
  {id: TIER_LOW, title: "Extremely Data-Poor", sortOrder:3, icon:<DataPoorIcon />},
  {id: TIER_MID, title: "Mid-tier", sortOrder:2, icon:<DataModerateIcon />},
  {id: TIER_HIGH, title: "High Tier", sortOrder:1, icon:<DataRichIcon />}
]


const AssessmentTier = ({ assessmentTier, onClick }) => {
  let icon = "";
  if(assessmentTier){
    icon = assessmentTiers.find(tier => tier.id === assessmentTier).icon
  }

  return (
    <div
      onClick={onClick}
      style={{
        ...containerStyle,
        position: "relative",
        paddingTop: (assessmentTier === TIER_PRELH || assessmentTier === TIER_PRERISK) ? 5 : 0,
        cursor: "pointer",
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        minWidth: 70,
        maxWidth: 70,
        textAlign: "center",
        fontWeight: "bold"
      }}
    >
      {icon}
    </div>
  )
};

AssessmentTier.style = containerStyle;

export default AssessmentTier;
